module.exports = __webpack_public_path__ + "img/serveLogo1.f071e256.png";